import { Button, createStyles, Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import Logo from '../../assets/logo/logo_yellow_cropped.png';
import LightInput from '../../components/LightInput/LightInput.component';
import AppSideMenuComponent from '../../components/SideMenu/SideMenu.component';

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
        },
        logo: {
            maxHeight: 120,
            paddingTop: 10,
            paddingBottom: 10,
        },
        input: {
            minWidth: 300,
            [theme.breakpoints.down('sm')]: {
                minWidth: 'unset',
            }
        }
    }),
);

interface Props {
    onChange: (key: string) => (value: any) => void,
    onSubmit: () => void
    error?: string
    values: {
        email: string,
        password: string
    }
}

export default function LoginPage({
    onChange,
    onSubmit,
    error,
    values
}: Props) {
    const [open, setOpen] = React.useState(true);
    const classes = useStyles();

    return (
        <AppSideMenuComponent
            open={open}
            setOpen={setOpen}
        >
            <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
                <Grid container spacing={3} direction="column" justify="center" alignItems="center">
                    <Grid item>
                        <img className={classes.logo} src={Logo} alt="PubPoints logo" />
                    </Grid>
                    <Grid item>
                        <LightInput
                            placeholder="Email..."
                            type="email"
                            value={values.email}
                            onChange={onChange("email")}
                        />
                    </Grid>
                    <Grid item>
                        <LightInput
                            placeholder="Password..."
                            type="password"
                            value={values.password}
                            onChange={onChange("password")}
                        />
                    </Grid>
                    {error ? (
                        <Grid item>
                            <Typography color="error">{error}</Typography>
                        </Grid>
                    ) : null}
                    <Grid item>
                        <Button
                            type="submit" variant="contained"
                            color="primary"
                        >
                            Login
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </AppSideMenuComponent>
    )
}
